import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEnvironmentService } from '../../../core/services/environment/environment.interface';
import { shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FinanceService {
  private readonly endpointApi: string;
  private optionsStorage = [];

  constructor(private http: HttpClient, @Inject('IEnvironmentService') private envService: IEnvironmentService) {
    this.endpointApi = this.envService.getVar('services.api') as string;
  }

  public getOptions(action: string, repository: string, key: string, value: string): Observable<any> {
    const existingRequestIndex = this.optionsStorage.findIndex(
      (request) => request.action === action && request.repository === repository && request.key === key && request.value === value
    );

    const body = {
      action,
      arguments: {
        [key]: value,
      },
      repository,
    };

    if (existingRequestIndex > -1) {
      const timestampNow = Date.now();
      if (timestampNow - this.optionsStorage[existingRequestIndex].timestamp > 20000) {
        this.optionsStorage[existingRequestIndex].timestamp = timestampNow;
        this.optionsStorage[existingRequestIndex].request = this.createHttpRequest(body);
      }
      return this.optionsStorage[existingRequestIndex].request;
    }

    const request = this.createHttpRequest(body);

    this.optionsStorage.push({ action, repository, key, value, request, timestamp: Date.now() });

    return request;
  }

  private createHttpRequest(body: any): Observable<any> {
    return this.http.post(`${this.endpointApi}/action/options`, body).pipe(shareReplay());
  }
}
